import * as React from 'react';

import type { DisplayViewEquipmentViewModel } from 'ab-viewModels/scheduleBoardDisplayView.viewModel';

import { chunkArray } from '@acceligentllc/shared/utils/array';

import { DISPLAY_VIEW_NUMBER_OF_ITEMS_IN_COLUMN } from 'af-constants/values';

import AvailableEquipmentColumn from './AvailableEquipmentColumn';

interface OwnProps {
	status: Nullable<string>;
	equipmentList: DisplayViewEquipmentViewModel[];
}

type Props = OwnProps;

const AvailableEquipmentGroup: React.FC<Props> = (props: Props) => {
	const { status, equipmentList } = props;
	const equipmentGroups = chunkArray<DisplayViewEquipmentViewModel>(equipmentList, DISPLAY_VIEW_NUMBER_OF_ITEMS_IN_COLUMN);

	return (
		<div className="display-view-group">
			<div className="display-view-group-title">
				<img src="/images/elements/ic_state_complete.svg" />
				<span className="ellipsed display-view-group-title-text">
					{status}
				</span>
			</div>
			<div className="display-view-columns-wrapper">
				{
					equipmentGroups.map((_equipmentGroup, _index) => (
						<AvailableEquipmentColumn equipmentGroup={_equipmentGroup} key={_index} />
					))
				}
			</div>
		</div>
	);
};

export default React.memo(AvailableEquipmentGroup);
